import { render, staticRenderFns } from "./AsignacionClienteGps.vue?vue&type=template&id=55868cfc&scoped=true&"
import script from "./AsignacionClienteGps.vue?vue&type=script&lang=ts&"
export * from "./AsignacionClienteGps.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionClienteGps.vue?vue&type=style&index=0&id=55868cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55868cfc",
  null
  
)

export default component.exports